import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const CardTitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin: 0;
`

export const CardDescription = styled(Description)``

export const CardList = styled('ul')`
  margin: 15px 0 0;
  padding: 0 0 0 20px;
`

export const CardItem = styled('li')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 8px;
`
